import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const GAMESHOW_ROUTE = {
  name: 'gameshow',
  route(classId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), GAMESHOW_ROUTE.name];
  },
  DEFAULT: '',

  LAUNCH: {
    name: '',
    route(classId: string): string[] {
      return [...GAMESHOW_ROUTE.route(classId)];
    }
  },

  FEEDBACK: {
    name: 'feedback/:gameShowRunId/:attemptNumber',
    route(classId: string, gameShowRunId: string, attemptNumber: number): string[] {
      return [...GAMESHOW_ROUTE.route(classId), 'feedback', gameShowRunId, attemptNumber.toString()];
    }
  },

  GAME: {
    name: ':gameShowRunId/:attemptNumber',
    route(classId: string, gameShowRunId: string, attemptNumber: number): string[] {
      return [...GAMESHOW_ROUTE.route(classId), gameShowRunId, attemptNumber.toString()];
    }
  }
};
